import { defineFilePond, type Locale as FilepondLocale } from "filepond";
import { locale as localeEs } from "filepond/locales/es-es";
import "filepond/extensions/form-post-store";

let registered = false;

/** Registra el custom element `<file-pond>` una sola vez (locale por defecto ES). */
export function ensureFilePondRegistered(): void {
  if (registered) return;
  registered = true;
  defineFilePond({ locale: localeEs as unknown as FilepondLocale } as never);
}
